import { render } from "./mabangToKindee.vue?vue&type=template&id=fd9c063e&scoped=true"
import script from "./mabangToKindee.vue?vue&type=script&lang=js"
export * from "./mabangToKindee.vue?vue&type=script&lang=js"

import "./mabangToKindee.vue?vue&type=style&index=0&id=fd9c063e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd9c063e"]])

export default __exports__